/* eslint-disable no-template-curly-in-string */
import { Locale } from './locales';

export const globalTranslation = {
  [Locale.en]: {
    common: {
      space: ' ',
      colon: ':',
      to: 'to',
      of: 'of',
      from: 'from',
      ok: 'ok',
      connect: 'Connect',
      disconnect: 'Disconnect',
      connectWallet: 'Connect Wallet',
      switchNetwork: 'Switch Network',
      unsupportedNetwork: 'Unsupported network',
      unsupportedNetworkTooltip:
        'Please switch your wallet to the {network} network to continue',
      balance: 'Balance',
      getMore: 'Get more',
      max: 'MAX',
      none: '--',
    },
    chains: {
      'iota:devnet': 'IOTA Devnet',
      'iota:testnet': 'IOTA Testnet',
      'iota:mainnet': 'IOTA Mainnet',
    },
    unit: {
      $: '${value}',
      tokenValue: '{value} {token}',
      percent: '{value}%',
      compact: '{value, number, ::compact-short}',
    },
    tokens: {
      native: 'IOTA',
      staked: 'stIOTA',
      VUSD: 'VUSD',
    },
    validation: {
      required: 'This field is required',
      numberOnly: 'Must be a number',
      min: 'The minimum amount is {value} {unit}',
      max: 'Insufficient balance',
    },
    notification: {
      connectionRecovery: 'Connection recovery error',
      failedStats: 'Failed to get stats',
      failedStakingChartData: 'Failed to get data for staking chart',
      failedRatioChartData: 'Failed to get data for ratio chart',
    },
  },
};
